/**
 * Limits that both the API and the web app must agree on. The database CHECK constraints use the
 * same numbers (data model §3). Server-only limits (lockout, rate limits) live in the API.
 */
export const LIMITS = {
  userNameMax: 100,
  emailMax: 254,
  passwordMin: 10,
  passwordMax: 128,
  projectNameMax: 120,
  projectDescriptionMax: 5000,
  groupNameMax: 80,
  taskTitleMax: 500,
  notesMax: 2000,
  commentTextMax: 10_000,
  labelNameMax: 40,
  fileNameMax: 255,
  fileMaxBytes: 50 * 1024 * 1024,
  pageSizeDefault: 50,
  pageSizeMax: 100,
  searchQueryMax: 200,
  /** Work items reassigned in one deactivation (ADM-3). */
  reassignmentsMax: 2000,
  teamMembersMax: 200,
  /** ADR-0014: what a phone reports about itself when it signs in. */
  phoneNameMax: 100,
  appVersionMax: 40,
  /** D47: the note of a reminder you set (NTF-6). */
  reminderNoteMax: 200,
} as const;

/** Product timings visible to users (PRD TSK-6, TRS-3, AUTH-6, AUTH-7). */
export const TIMINGS = {
  undoToastSeconds: 10,
  trashRetentionDays: 30,
  invitationValidityDays: 7,
  passwordResetValidityMinutes: 60,
} as const;
